import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Введение</Summary>
        <Details>
          <Text>
            Данное уведомление о политике конфиденциальности данных клиента
            предоставлено фирмой <strong>Fresh Finance OÜ</strong> (также
            именуемой <strong>«Fresh Finance»</strong>, <strong>«мы»</strong>,{" "}
            <strong>«нас»</strong> или <strong>«наше»</strong>),
            зарегистрированной в соответствии с законодательством Эстонской
            Республики, с регистрационным номером 12243370 и юридическим адресом
            ул. Тартуское шоссе, 83, 10115 Таллинн, Эстонская Республика.{" "}
          </Text>
          <Text>
            Настоящая политика конфиденциальности распространяется на всех
            физических лиц, от которых или в отношении которых Fresh Finance
            собирает или получает персональные данные в ходе предоставления
            своих услуг или в ходе осуществления своей экономической
            деятельности иным образом (далее <strong>«субъект данных»</strong>{" "}
            или <strong>«Вы»</strong>) в той степени, в которой Fresh Finance
            обрабатывает Ваши персональные данные. Эта политика
            конфиденциальности описывает, как Fresh Financeсобирает, использует
            и иным образом обрабатывает Ваши персональные данные.
          </Text>
          <Text>
            Fresh Finance обрабатывает Ваши персональные данные в соответствии с
            действующим законодательством о защите данных, включая Общий
            регламент о защите данных (Постановление (ЕС) 2016/679) (англ.
            <em>General Data Protection Regulation</em>, далее{" "}
            <strong>«GDPR»</strong>) и любые иные применимые законодательные
            акты о защите данных.
          </Text>
          <Text>
            У Вас есть много прав, которые Вы можете использовать для контроля
            над Вашей конфиденциальностью. Fresh Finance уважает эти права и
            хочет помочь Вам реализовать Ваши права, и ниже Вы найдете
            информацию о том, как это сделать.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Контролёр данных</Summary>
        <Details>
          <Text>
            Fresh Finance OÜ – это Ваш контролёр данных. Fresh Finance OÜ несет
            ответственность за обработку Ваших персональных данных в
            соответствии с настоящей политикой конфиденциальности и применимыми
            законами о защите данных.
          </Text>
          <Text>
            Контактные данные лица, ответственного за защиту данных:
            <ul>
              <li>Krõõt Kilvet</li>
              <li>Адрес: Tartu mnt 83, 10115 Tallinn, Eesti</li>
              <li>
                Электронная почта:{" "}
                <a href="mailto:kroot.kilvet@punkfinance.ee">
                  kroot.kilvet@punkfinance.ee
                </a>
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Персональные данные, которые мы обрабатываем</Summary>
        <Details>
          <Text>
            Мы можем собирать, хранить, использовать, передавать и обрабатывать
            любым иным способом следующие категории Ваших персональных данных:
            <ul>
              <li>
                идентификационные данные (имя, фамилия, личный идентификационный
                код, дата и место рождения, гражданство, данные удостоверяющего
                личность документа и его копия, фотография и т. д.);
              </li>
              <li>
                контактные данные (адрес, номер телефона, адрес электронной
                почты и т. д.);
              </li>
              <li>
                данные о работе (нынешний работодатель, данные о предыдущих
                местах работы, должность и т. д.);
              </li>
              <li>
                финансовые данные (доходы, имущество, обязательства, данные о
                залоге и гарантии и т. д.);
              </li>
              <li>
                данные, касающиеся договора и его исполнения (текущие и
                предыдущие договоры с нами, история платежей и платежи по
                умолчанию, транзакции, заявки на выдачу займа и т. д.);
              </li>
              <li>
                данные, относящиеся к Вашей экономической деятельности,
                например, сведения о связанных лицах из коммерческого регистра;
              </li>
              <li>Ваш IP-адрес;</li>
              <li>
                судимости, информация о том, являетесь ли Вы политически
                уязвимым лицом и т. д.
              </li>
            </ul>
          </Text>
          <Text>
            В зависимости от типа персональных данных, о которых идет речь, и
            оснований, по которым Fresh Finance обрабатывает их, Fresh Finance
            может быть не в состоянии выполнить свои договорные обязательства
            или не сможет продолжить договорные отношения, если Вы откажетесь
            раскрывать определенные персональные данные.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Где собираются ваши персональные данные</Summary>
        <Details>
          <Text>
            Мы собираем Ваши персональные данные из следующих источников:
            <ul>
              <li>
                Вы – некоторые из Ваших персональных данных могут быть переданы
                Вами нам в Вашей заявке на выдачу займа, по телефону, по
                электронной почте, через онлайн-самообслуживание или любым иным
                способом, когда Вы общаетесь с нами;
              </li>
              <li>
                фирмы группы консолидируемых компаний, к которой принадлежит
                Fresh Finance;
              </li>
              <li>
                третьи лица, включая общедоступные источники, такие как
                электронные базы данных (такие как Регистр задолженностей по
                умолчанию, коммерческий регистр, Пенсионный регистр, Земельный
                кадастр, Регистр наказаний) и поисковые системы, государственные
                органы (суды, судебные приставы, банкротные управляющие) и
                другие лица.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Цели обработки ваших персональных данных</Summary>
        <Details>
          <Text>
            Fresh Finance обрабатывает Ваши персональные данные в соответствии с
            действующим законодательством о защите данных. Где это уместно и в
            соответствии с применимыми законами и правовыми требованиями, мы
            обычно используем данные клиентов в следующих целях:
            <ul>
              <li>
                чтобы оценить кредитоспособность клиента или гаранта, а также
                целесообразность и соответствие продукта, услуги и гарантий,
                предлагаемых клиенту;
              </li>
              <li>чтобы оценить целесообразность и соответствие залога;</li>
              <li>чтобы подготовить, составить и заключить договор;</li>
              <li>чтобы следить за выполнением договора клиентом;</li>
              <li>
                чтобы помочь нам устанавливать, предъявлять или защищать
                правовые требования;
              </li>
              <li>
                для проведения юридической экспертизы и соблюдения других
                нормативных требований;
              </li>
              <li>для целей бухгалтерского учета и отчетности;</li>
              <li>чтобы делать Вам новые предложения.</li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>
          Юридическая основа для обработки ваших персональных данных
        </Summary>
        <Details>
          <Text>
            Существует ряд различных оснований, которые позволяют Fresh Finance
            законно обрабатывать Ваши персональные данные. Это следующие
            основания:
            <ul>
              <li>
                чтобы подготовиться к заключению договора с Вами (GDPR, статья
                6(1)(b));
              </li>
              <li>
                чтобы выполнять обязательства по нашему договору с Вами и
                гарантировать, чтобы Вы должным образом выполняли свои
                обязательства перед Fresh Finance (GDPR, статья 6(1)(b));
              </li>
              <li>
                чтобы выполнять наши юридические обязательства (GDPR, статья
                6(1)(c)), такие как обязательства, вытекающие из Закона о
                противодействии отмыванию денег и финансированию терроризма,
                Обязательственно-правового закона, Закона о кредиторах и
                посредниках, Закона о бухгалтерском учёте, Закона об аудиторской
                деятельности, Закона о международных санкциях;
              </li>
              <li>
                когда обработка находится в наших законных интересах (GDPR,
                статья 6(1)(f)), в основном в тех случаях, когда:
                <ul>
                  <li>
                    обработка Ваших персональных данных необходима нам для
                    установления, предъявления или защиты законных требований;
                  </li>
                  <li>
                    обработка Ваших персональных данных необходима для оценки
                    потенциальных клиентов, гарантов и залогодателей (лиц,
                    поставляющий обеспечение), в случае если такая обработка не
                    требуется применимым законом;
                  </li>
                  <li>
                    обработка Ваших персональных данных необходима для
                    подготовки новых предложений для Вас.
                  </li>
                </ul>
              </li>
              <li>
                если Вы дали согласие на такую обработку (GDPR статья 6(1)(a)).
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Передача ваших персональных данных</Summary>
        <Details>
          <Text>
            Чтобы мы могли выполнить задачи обработки, описанные в этом
            уведомлении о конфиденциальности, Ваши персональные данные могут
            быть переданы следующим категориям получателей:
            <ul>
              <li>
                предприятиям группы консолидируемых компаний, к которой
                принадлежит Fresh Finance;
              </li>
              <li>
                государственным органам, таким как Налогово-таможенный
                департамент, Финансовая инспекция, Бюро данных об отмывании
                денег, контролёры баз данных;
              </li>
              <li>
                провайдерам облачных хранилищ в том числе поставщику
                программного обеспечения для облачного сервиса управления
                кредитами;
              </li>
              <li>поставщикам услуг центра поддержки клиентов;</li>
              <li>
                компаниям, предоставляющим услуги по предотвращению
                мошенничества и финансовых преступлений;
              </li>
              <li>
                другим третьим сторонам, таким как поставщики курьерских и
                почтовых услуг, реестры платежей по умолчанию, поставщики услуг
                по взысканию долгов, аудиторы, поставщики юридических услуг,
                суды, судебные приставы, банкротные управляющие и т. д.
              </li>
            </ul>
          </Text>
          <Text>
            Мы требуем, чтобы наши сторонние поставщики услуг сохраняли Вашу
            информацию в безопасности и обрабатывали эту информацию согласно
            нашим инструкциям и требованиям в соответствии с настоящим
            уведомлением, GDPR и применимым законодательством.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Передача данных за пределы ЕЭЗ</Summary>
        <Details>
          <Text>
            Мы передаем данные за пределы Европейской экономической зоны (ЕЭЗ, в
            которую входят государства-члены Европейского союза вместе с
            Норвегией, Исландией и Лихтенштейном) только в тех случаях, когда
            это соответствует законодательству о защите данных и средства
            передачи обеспечивают адекватные гарантии в отношении Ваших данных.
            Что касается передачи данных в страны, не обеспечивающие адекватный
            уровень защиты, мы основываем передачу на соответствующих гарантиях,
            таких как стандартные положения о защите данных, принятые
            Европейской комиссией, или утвержденные механизмы сертификации
            вместе с обязательными и подлежащими исполнению обязательствами
            получателя. Если вам нужна дополнительная информация о передаче
            персональных данных и мерах безопасности, которые мы применяем,
            свяжитесь с нами, используя контактную информацию, указанную в этом
            заявлении о конфиденциальности.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Хранение и безопасность ваших персональных данных</Summary>
        <Details>
          <Text>
            Мы не будем хранить Ваши персональные данные дольше, чем это
            необходимо для целей обработки. Критерии, применяемые для
            определения срока хранения Ваших персональных данных, следующие:
            <ul>
              <li>характер цели, почему персональные данные были собраны;</li>
              <li>
                промежуток времени, в течение которого Fresh Finance
                поддерживает с Вами постоянные отношения;
              </li>
              <li>
                наличие правового обязательства в соответствии с применимым
                законодательством;
              </li>
              <li>
                необходимость в свете правовой позиции Fresh Finance (например,
                применимых сроков давности, судебных разбирательств или
                предписанных госорганами расследований).
              </li>
            </ul>
          </Text>
          <Text>
            Как только мы определим, что нам больше не нужно хранить Ваши
            персональные данные, мы удалим их из систем Fresh Finance.
          </Text>
          <Text>
            Мы внедрили общепринятые стандарты технологий и операционной
            безопасности, чтобы защитить Ваши персональные данные от потери,
            ненадлежащего использования, изменения или уничтожения. Мы требуем,
            чтобы весь персонал сохранял конфиденциальность персональных данных
            и чтобы только авторизованный персонал имел доступ к этим данным.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Ваши права</Summary>
        <Details>
          <Text>
            У Вас есть различные права в отношении Ваших персональных данных,
            которые мы обрабатываем:
            <ul>
              <li>
                <strong>Право запрашивать доступ:</strong> Вы можете в любое
                время попросить нас подтвердить, какую информацию о Вас мы
                обрабатываем. Мы можем отклонить Ваш запрос, если мы обязаны это
                сделать в соответствии с законом. Если мы отклоним Ваш запрос,
                мы сообщим Вам причины этого.
              </li>
              <li>
                <strong>Право на исправление:</strong> Вы можете потребовать,
                чтобы мы исправили любые неточные или неполные персональные
                данные, которые мы обрабатываем в отношении Вас. Если мы
                передали эти персональные данные третьим лицам, мы уведомим их
                об исправлении, за исключением тех случаев, когда это невозможно
                или требует непропорциональных усилий. Мы можем отклонить Ваш
                запрос, если в соответствии с законом нам разрешено это сделать.
                Если мы отклоним Ваш запрос, мы сообщим Вам причины этого.
              </li>
              <li>
                <strong>Право на удаление:</strong> Вы имеете право потребовать,
                чтобы мы удалили Ваши персональные данные в определенных
                обстоятельствах. Мы можем отклонить Ваш запрос, если в
                соответствии с законом нам разрешено это сделать. Если мы
                отклоним Ваш запрос, мы сообщим Вам причины этого.
              </li>
              <li>
                <strong>Право на ограничение обработки:</strong> Вы имеете право
                ограничить обработку Ваших персональных данных при определенных
                обстоятельствах. Это означает, что мы сможем только продолжать
                хранить Ваши данные и не сможем выполнять какие-либо дальнейшие
                действия по обработке. Мы можем отклонить Ваш запрос, если в
                соответствии с законом нам разрешено это сделать. Если мы
                отклоним Ваш запрос, мы сообщим Вам причины этого.
              </li>
              <li>
                <strong>Право на возражение:</strong> при определенных
                обстоятельствах Вы имеете право возражать против обработки нами
                Ваших персональных данных. Мы можем отклонить Ваш запрос, если в
                соответствии с законом нам разрешено это сделать. Если мы
                отклоним Ваш запрос, мы сообщим Вам причины этого.
              </li>
              <li>
                <strong>Право на переносимость данных:</strong> Вы имеете право
                передавать свои персональные данные между контролёрами данных с
                учетом возможных ограничений действующего законодательства. Это
                означает, что Вы можете передавать обрабатываемые нами данные о
                Вас другому поставщику услуг или третьей стороне. Мы предоставим
                Вам Ваши данные в широко используемом машиночитаемом формате,
                чтобы Вы могли передать данные другому поставщику услуг.
              </li>
              <li>
                <strong>
                  Право не быть предметом решения, основанного исключительно на
                  автоматизированной обработке:
                </strong>{" "}
                у Вас есть право не подвергаться решению, основанному
                исключительно на автоматизированной обработке, включая
                профилирование, которое создает юридические последствия для Вас
                или схожим образом влияет на Вас. На это право распространяются
                ограничения действующего законодательства. Мы можем отклонить
                Ваш запрос, если нам по закону разрешено это сделать. Если мы
                отклоним Ваш запрос, мы сообщим Вам причины этого.
              </li>
              <li>
                <strong>Право подать жалобу в надзорный орган:</strong> если у
                Вас есть какие-либо сомнения относительно способа обработки
                Ваших персональных данных, Вы можете связаться с Инспекцией по
                защите данных (эст. <em>Andmekaitse Inspektsioon</em>),
                используя следующие контактные данные: Инспекция по защите
                данных, ул. Татари, 39, 10134 Таллинн, тел. +372 627 4135, эл.
                почта: <a href="mailto:info@aki.ee">info@aki.ee</a>.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Внесение изменений</Summary>
        <Details>
          <Text>
            Если Fresh Finance изменит категории персональных данных, которые
            обрабатывает, или изменит цели обработки персональных данных, мы
            внесем соответствующие изменения в это уведомление и проинформируем
            Вас об этом.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Дополнительная помощь</Summary>
        <Details>
          <Text>
            Если у Вас есть какие-либо вопросы об этом уведомлении о политике
            конфиденциальности или о Ваших персональных данных, пишите нам,
            пожалуйста, на электронную почту:{" "}
            <a href="mailto:kroot.kilvet@punkfinance.ee">
              <strong>kroot.kilvet@punkfinance.ee</strong>
            </a>
            .
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
